export function loopThroughElements(elements: NodeListOf<Element> | HTMLCollectionOf<Element>, action: (HTMLElement) => any): void {
    for (let i = 0; i < elements.length; i++) {
        const el = <HTMLElement>elements[i];
        action(el);
    }
}
